import React, { useState } from "react";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import "./CANavbar.css";
import logo from "../../asset/logo.png";
import contactImage from "../../asset/contact.png";

const CANavbar = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => {
    setExpanded(false);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <Navbar expand="lg" className="ca-navbar shadow" fixed="top" expanded={expanded} onToggle={setExpanded}>
      <Container fluid>
        <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center logo-brand" onClick={handleNavClick}>
          <img src={logo} alt="Logo" height="60" className="me-2" />
          <div className="logo-text-wrapper">
            <div className="company-name">CA Sudarshan V. Kalunge & CO.</div>
            <div className="company-type">CHARTERED ACCOUNTANTS</div>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center nav-links">
            <Nav.Link as={NavLink} to="/" onClick={handleNavClick} className="nav-item">
              {({ isActive }) => <span className={`nav-text ${isActive ? "active" : ""}`}>HOME</span>}
            </Nav.Link>

            <Nav.Link as={NavLink} to="/about" onClick={handleNavClick} className="nav-item">
              {({ isActive }) => <span className={`nav-text ${isActive ? "active" : ""}`}>ABOUT</span>}
            </Nav.Link>

            <NavDropdown
              title={<span className={`nav-text ${location.pathname.startsWith("/services") ? "active" : ""}`}>SERVICES</span>}
              id="services-dropdown"
              className="nav-item"
            >
              <NavDropdown.Item as={NavLink} to="/services/accounting" onClick={handleNavClick}>Accounting</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/consulting" onClick={handleNavClick}>Consultancy</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/tds" onClick={handleNavClick}>TDS</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/indirect-taxation" onClick={handleNavClick}>Indirect Taxation</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/audit-assurance" onClick={handleNavClick}>Audit & Assurance</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/corporate-governance" onClick={handleNavClick}>Corporate Governance</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/business-startup" onClick={handleNavClick}>Business Start-up Services</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/professional-governance" onClick={handleNavClick}>Professional Governance</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={NavLink} to="/gallery" onClick={handleNavClick} className="nav-item">
              {({ isActive }) => <span className={`nav-text ${isActive ? "active" : ""}`}>GALLERY</span>}
            </Nav.Link>

            <Nav.Link as={NavLink} to="/contact" onClick={handleNavClick} className="contact-img nav-item d-lg-none">
              {({ isActive }) => (
                <div className={`contact-wrapper ${isActive ? "active" : ""}`}>
                  <img src={contactImage} alt="Contact" />
                  <span className="contact-text">CONTACT</span>
                </div>
              )}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>

        <Nav className="d-none d-lg-flex ms-4">
          <Nav.Link as={NavLink} to="/contact" onClick={handleNavClick} className="contact-img nav-item">
            {({ isActive }) => (
              <div className={`contact-wrapper ${isActive ? "active" : ""}`}>
                <img src={contactImage} alt="Contact" />
                <span className="contact-text">CONTACT</span>
              </div>
            )}
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default CANavbar;
